<template>
  <div class="home-service">
    <nav-header :activeIndex="1" />
    <main class="home-service-content">
      <section class="home-service-content-sec">
        <div class="home-service-content-sec-title">
          <p>专业领域</p>
        </div>
        <div class="home-service-content-sec-content-field">
          <router-link tag="div" v-for="(item, index) in field" :key="index"
               :to="{name: 'field-detail', query: {id: item.id}}"
               :class="['home-service-content-sec-content-field-item', index === activeIndex ? 'active' : '']">
            {{item.title}}
          </router-link>
          <div class="home-service-content-sec-content-field-item" style="opacity: 0">其他</div>
        </div>
      </section>
      <lawyer-list :lawyerList="lawyerList" @getCity="getCity">
        <router-link tag="div" :to="{name: 'home-lawyer'}" class="home-wrap-content-sec-lawyer-btn">查看更多律师</router-link>
      </lawyer-list>
      <article-list :articleList="articleList">
        <router-link tag="div" :to="{name: 'home-article'}" class="home-service-content-sec-content-article-btn">查看更多文章</router-link>
      </article-list>
      <select-us />
    </main>
  </div>
</template>

<script>
  import Icon from '@/common-components/icon'
  import LawyerList from '@/common-components/lawyer-list'
  import ArticleList from '@/common-components/article-list'
  import SelectUs from '@/common-components/select-us'
  import NavHeader from '@/common-components/nav-header'
  import api from './api'
  import { Message } from 'element-ui/lib'
  export default {
    name: 'home-service',
    components: {
      Icon, LawyerList, SelectUs, ArticleList, NavHeader
    },
    data () {
      return {
        field: [
          {title: '婚姻家庭', id: 'B7AC75DD-6163-48D9-89A4-E88A3DEEBD84'},
          {title: '刑事辩护', id: 'F0F9C7F8-AA04-4703-929B-F8FB1DC447CF'},
          {title: '合同纠纷', id: 'B6736053-3D9F-4593-9905-A913169F63AC'},
          {title: '债权债务', id: 'B1180304-2905-4CD0-BBCF-695A9641E00D'},
          {title: '房产纠纷', id: 'DE0CA56E-E967-4DDD-9A23-AD6EBC285F30'}
        ],
        lawyerList: [],
        articleList: null,
        activeIndex: '',
        city: ''
      }
    },
    mounted () {
      this.getArticleList()
    },
    methods: {
      // 路由跳转
      navigatorRoute (path) {
        let router = this.$router.resolve({
          name: path
        })
        window.open(router.href)
      },
      // 获取律师列表
      async getPositionLawyer () {
        let obj = {
          pageIndex: 1,
          pageSize: 3,
          city: this.city
        }
        let res = await api.getPositionLawyerList(obj)
        if (res.data.isSuccess) {
          this.lawyerList = res.data.data.list
        } else {
          Message.error(res.data.resultMsg)
        }
      },
      // 获取文章列表
      async getArticleList () {
        let params = {
          pageIndex: 1,
          pageSize: 5,
          title: ''
        }
        api.getArticleList(params).then(res => {
          this.articleList = res.data.data.list
        })
      },
      // 获取地理位置
      getCity (city) {
        this.city = city
        this.getPositionLawyer()
      }
    }
  }
</script>

<style lang='stylus' scoped>
  @import '../../styles/constant.styl'
  .home-service {
    &-content {
      margin-top .72rem
      background #f7f7f7
      padding .96rem 0 0 0
      .select {
        background #fff
        padding .48rem 0 1.16rem 0
        .line {
          width: 1.32rem;
          height: .04rem;
          margin: 0 auto .32rem
          background-color: #ed6c00;
        }
        .title  {
          height: .5rem;
          font-size: .36rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #000000;
          text-align center
          margin-bottom .48rem
        }
      }
      &-sec {
        width: 9.6rem
        margin 0 auto
        &-title {
          display: flex
          justify-content space-between
          height: .32rem
          align-items center
          p {
            height: .32rem
            border-left .04rem solid #ed6c00
            font-size: .24rem;
            padding-left .16rem
          }
        }
        &-content-field {
          display flex
          justify-content space-around
          flex-wrap wrap
          margin-top .12rem
          &-item {
            width: 3rem;
            height: .48rem;
            flex-shrink 0
            border-radius: .04rem;
            background-color: #ffffff;
            text-align: center;
            color: #1d1b1b;
            line-height .48rem
            margin-top .2rem
            font-size: .16rem
            cursor pointer
          }
          .active {
            color: #ed6c00;
          }
        }
        &-content-article-btn {
          width: 4.32rem
          height: .64rem
          background-color: #ed6c00;
          font-size: .24rem
          text-align: center;
          color: #ffffff
          line-height .64rem
          margin .48rem auto .72rem
          cursor pointer
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/service/service.vue